import { postInstalmentRequest } from '../../../../../../resources/contract/actions';
import { InstalmentViewModel } from '../../../../../../resources/contract/types';
import { useGetEmptyInstalment } from '../../../../../../resources/contract/hooks';

import {
    InstalmentModalActions,
    Props as InstalmentModalActionsProps,
} from './InstalmentModalActions';

type DuplicateInstalmentModalProps = Omit<
    InstalmentModalActionsProps,
    'title' | 'submitTextButton' | 'instalment' | 'submitAction'
> & {
    currency: string;
    instalment: InstalmentViewModel;
};

export const DuplicateInstalmentModal = (props: DuplicateInstalmentModalProps) => {
    const { currency, instalment, ...restProps } = props;
    const { contractId } = props;

    const newInstalment = useGetEmptyInstalment(instalment.type, contractId, currency, instalment);

    return (
        <InstalmentModalActions
            {...restProps}
            title="contract.payment_schedule.modal.title.duplicate"
            submitTextButton="contract.payment_schedule.modal.submit.create"
            instalment={newInstalment}
            submitAction={postInstalmentRequest}
        />
    );
};
